import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon } from 'lucide-react';
const testimonials = [{
  name: 'María',
  country: 'Colombia',
  flag: '🇨🇴',
  text: 'De ganar $1.800.000 COP a facturar $800 USD/mes como asistente virtual. El paso a paso de Airtm me salvó la vida.'
}, {
  name: 'Carlos',
  country: 'México',
  flag: '🇲🇽',
  text: 'Dejé mi trabajo de $12,000 MXN y ahora gano $1,200 USD desde casa. Las plantillas de mensajes son oro puro.'
}, {
  name: 'Andrea',
  country: 'Chile',
  flag: '🇨🇱',
  text: 'Sin saber inglés, conseguí mi primer cliente en 11 días. Pensé que era imposible hasta que leí la página 7.'
}];
export function SocialProof() {
  return <section className="py-24 px-4 bg-[#0f0f0f] border-y border-neutral-800" data-id="element-130">
      <div className="max-w-6xl mx-auto" data-id="element-131">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16 max-w-3xl mx-auto" data-id="element-132">
          <h2 className="text-3xl md:text-5xl font-extrabold text-white mb-6" data-id="element-133">
            ¿Por Qué Funciona?
          </h2>
          <p className="text-xl text-[#D1D5DB] mb-4" data-id="element-134">
            Este método ya ha sido usado por cientos de personas en Bogotá,
            Santiago y CDMX para pasar de cobrar $500 mil pesos a facturar{' '}
            <span className="text-[#1A7A4A] font-bold" data-id="element-135">
              $500 dólares al mes
            </span>{' '}
            en su tiempo libre.
          </p>
          <p className="text-2xl font-bold text-[#C9A84C]" data-id="element-136">
            No es teoría, es un sistema probado.
          </p>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-8" data-id="element-137">
          {testimonials.map((t, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: idx * 0.2,
          duration: 0.5
        }} className="bg-[#0A0A0A] p-8 rounded-2xl border border-neutral-800 relative" data-id="element-138">
              <div className="flex gap-1 mb-4" data-id="element-139">
                {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-5 h-5 fill-[#C9A84C] text-[#C9A84C]" data-id="element-140" />)}
              </div>
              <p className="text-[#D1D5DB] text-lg mb-6 italic" data-id="element-141">"{t.text}"</p>
              <div className="flex items-center gap-3 mt-auto" data-id="element-142">
                <div className="w-10 h-10 rounded-full bg-neutral-800 flex items-center justify-center text-xl" data-id="element-143">
                  {t.flag}
                </div>
                <div data-id="element-144">
                  <p className="text-white font-bold" data-id="element-145">{t.name}</p>
                  <p className="text-neutral-500 text-sm" data-id="element-146">{t.country}</p>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}